/**
 * Utility functions for court and lite booking tables.
 */
(function (ebusy, $) {

    ebusy.bookingTableUtils = ebusy.bookingTableUtils || {};

    ebusy.bookingTableUtils.initBookingTable = function(moduleConfig, advanceCurrentTimeMarker) {

        var table = $(".table-booking-module");

        if(!table.length) {
            return;
        }

        if(ebusy.kioskMode === "true") {
            registerIdleDayTimeUpdater(moduleConfig);
        }

        registerAutoScroll();

        if(ebusy.autoRefresh.enabled) {
            registerAutoRefreshListener(table);
        }

        var removeReservation = ebusy.bookingTableUtils.styles[moduleConfig.bookingsTableStyle].removeReservation;
        var createReservation = ebusy.bookingTableUtils.styles[moduleConfig.bookingsTableStyle].createReservation;

        displayPriceZones(moduleConfig.priceZones, moduleConfig.view, table);
        registerReservationChangeListener(table, moduleConfig, removeReservation, createReservation);
        handleTooltip();

        initCourtNavigationButton("prev");
        initCourtNavigationButton("next");

        /**
         * Handles click events on booking table slots.
         */
        $(document).on("click", ".table-booking-module .slot", function() {
            ebusy.startBookingFlow($(this), moduleConfig);
        });

        /**
         * Click handler for reservation.
         */
        $(document).on("click", ".table-booking-module .reservation", function() {
            ebusy.loadModal($(this).find(".reservation-content").data("link"));
        });

        if(advanceCurrentTimeMarker) {
            initCurrentTimeMarker(table);
        }

        initPrintViewButton(moduleConfig);

        table.trigger("reservation-change");
    }

    ebusy.bookingTableUtils.getCellsById = function (reservationId, table) {
        return table.find("td").filter(function() {
            return $(this).data("reservation-id") === reservationId;
        });
    };

    /**
     * Register listener for reservation change event.
     */
    function registerReservationChangeListener(table, moduleConfig, removeReservation, createReservation) {

        // the page and the day this table shows, kept from its start: a dialog may change the address later - the
        // payment writes PayPal's cancel URL into the history before it leaves, and a refresh in that moment asked
        // /paypal/return for the reservations (400)
        var reservationsUrl = window.location.pathname;
        var selectedDate = ebusy.getParam("selectedDate") || ebusy.getParam("currentDate");

        $(document).on("reservation-change", ".table-booking-module", function() {

            updateReservations(
                reservationsUrl,
                selectedDate,
                moduleConfig.reservationsModel.timestamp,
                function (reservationsModel) {
                    var reservations = reservationsModel.reservations || [];
                    var courtRelations = reservationsModel.courtRelations || [];
                    clearAllCourtRelations(table);
                    processReservations(
                        reservations,
                        removeReservation,
                        createReservation,
                        table,
                        moduleConfig
                    );
                    applyCourtRelations(courtRelations, reservations, table);

                    var adminNotificationBar = $("#admin-notification-bar");
                    if (!reservationsModel.suppressedReservationsCount) {
                        adminNotificationBar.addClass("d-none");
                    } else {
                        adminNotificationBar
                            .find(".alert")
                            .text(ebusy.notificationSuppressedReservationsCount.replace("{0}", reservationsModel.suppressedReservationsCount));
                        adminNotificationBar.removeClass("d-none");
                    }

                    moduleConfig.reservationsModel = reservationsModel;
                }
            );
        });
    }

    function updateReservations(url, selectedDate, timestamp, dataHandler) {

    	var timer = null;

    	if(!timestamp) {
    		// show loading animation after 500ms
    		timestamp = null;
    		timer = setTimeout(function() {
    			$("#booking-table-overlay").removeClass("d-none").addClass("d-flex");
    		}, 500);
    	}

    	var data = {
    		timestamp : timestamp,
			selectedDate : selectedDate
    	};

        $.getJSON(url, data, function(reservationsModel, textStatus, jqXHR) {

            // hide loading animation
        	if(timer != null) {
        		clearTimeout(timer);
        	}

        	$("#booking-table-overlay").addClass("d-none").removeClass("d-flex");

            if(jqXHR.status === 304) {
                return;
            }

            dataHandler(reservationsModel);
        });
    }

    function handleTooltip() {
        /**
         * Handle tooltip.
         */
        window.tooltipVisible = false;

        if($("#next-court").is(":visible")) {
            $("#next-court").tooltip("show");
            window.tooltipVisible = true;
        }

        $(document).on("click scroll", function() {
            if(window.tooltipVisible) {
                $("#next-court").tooltip("hide");
                window.tooltipVisible = false;
            }
        });

        $(window).on("resize", function() {
            if(window.tooltipVisible) {
                $("#next-court").tooltip("hide");
                window.tooltipVisible = false;
            }
        });
    }

    function processReservations(reservations, removeReservation, createReservation, table, moduleConfig) {

        var idsToAdd = [];

        reservations.forEach(function(reservation) {
            idsToAdd.push(reservation.id);
        });

        table.find(".reservation").each(function() {
            var reservationId = $(this).data("reservation-id");
            var index = idsToAdd.indexOf(reservationId);
            if (index === -1) {
                removeReservation(reservationId, table, moduleConfig);
            }
        });

        reservations.forEach(function(reservation) {
            removeReservation(reservation.id, table, moduleConfig);

            var cells = getCellsByData(
                reservation.court,
                reservation.date,
                reservation.fromTime,
                reservation.toTime,
                table
            );
            if(cells.length) {
                createReservation(reservation, cells, table, moduleConfig);
            }
        });

        table.find('.reservation-content[data-toggle="tooltip"]').tooltip();
    }

    /**
     * Display price zones.
     */
    function displayPriceZones(priceZones, view, table) {
        if($("#hide-prices").length) {
            if(priceZones) {
                priceZones.forEach(function(priceZone) {
                    applyPriceZone(
                        priceZone,
                        view === "DAY",
                        function (cell) {
                            return cell.data("major-begin") === cell.data("minor-begin");
                        },
                        table
                    );
                });
            }
        }
    }

    /**
     * Applies a price zone to the booking table.
     */
    function applyPriceZone(priceZone, isDayView, cellFilter, table) {

        var court = priceZone.court;
        var weekday = priceZone.weekday;
        var fromTime = priceZone.fromTime;
        var toTime = priceZone.toTime;

        var first = table.find("td")
            .filter("[data-court='" + court + "']")
            .filter("[data-weekday='" + weekday + "']")
            .filter("[data-minor-begin='" + fromTime + "']");

        var last = table.find("td")
            .filter("[data-column='" + first.data("column") + "']")
            .filter("[data-minor-end='" + toTime + "']");

        var cells = table.find("td")
            .filter("[data-column='" + first.data("column") + "']")
            .filter(function() { return $(this).closest("tr").index() >= first.closest("tr").index() })
            .filter(function() { return $(this).closest("tr").index() <= last.closest("tr").index() });

        if(!cells.length) {
            return;
        }

        var price = isDayView ? priceZone.priceLong : priceZone.priceShort;

        cells.each(function() {
            if(cellFilter($(this))) {
                $(this).find(".slot-label").html($("<span>" + price + "</span>"));
            }
        });
    }

    function getCellsByData(court, date, fromTime, toTime, table) {
        var slots = table.find("td");

        var first = slots
            .filter("[data-court='" + court + "']")
            .filter("[data-date='" + date + "']")
            .filter("[data-minor-begin='" + fromTime + "']");

        var last = slots
            .filter("[data-column='" + first.data("column") + "']")
            .filter("[data-minor-end='" + toTime + "']");

        return slots
            .filter("[data-column='" + first.data("column") + "']")
            .filter(".slot")
            .filter(function() { return $(this).closest("tr").index() >= first.closest("tr").index() })
            .filter(function() { return $(this).closest("tr").index() <= last.closest("tr").index() });
    }

    function initCourtNavigationButton(direction) {

        var singleStep = !$(".table-day").length;

        var buttonSelector = direction === "prev" ? "#prev-court" : "#next-court";
        var button = $(buttonSelector);
        var reverseButton = $(direction === "prev" ? "#next-court" : "#prev-court");

        if (ebusy.isTouchDevice()) {
            var swipeEvent = direction === "prev" ?
                "swiperight" :
                "swipeleft";
            $(document).on(swipeEvent, ".table-day", function () {
                $(button).trigger("click");
            });
        }

        $(document).on("click", buttonSelector, function() {

            var visibleCourts = $(".court:visible");
            var followingCourts = direction === "prev" ?
                visibleCourts.last().prevAll(".court:hidden") :
                visibleCourts.last().nextAll(".court:hidden");

            if(!followingCourts.length) {
                return;
            }

            if (singleStep) {
                followingCourts = followingCourts.first();
            } else if (followingCourts.length === 2 || followingCourts.length === 4) {
                followingCourts = $([followingCourts.get(0), followingCourts.get(1)]);
            } else {
                followingCourts = $([followingCourts.get(0), followingCourts.get(1), followingCourts.get(2)]);
            }

            $(".date.mobile-view-only").attr("colspan", followingCourts.length);
            $(".court-select").attr("colspan", followingCourts.length);

            reverseButton.removeClass("disabled");
            visibleCourts.addClass("desktop-view-only");
            followingCourts.removeClass("desktop-view-only");

            var endReached = direction === "prev" ?
                !followingCourts.first().prevAll(".court:hidden").length :
                !followingCourts.last().nextAll(".court:hidden").length;
            if(endReached) {
                button.addClass("disabled");
            }

            var allCourts = $(".court");
            allCourts.addClass("desktop-view-only");
            allCourts.removeClass("first-court");

            var allSlots = $(".slot");
            allSlots.addClass("desktop-view-only");
            allSlots.removeClass("first-court");

            $(".reservation").addClass("desktop-view-only");
            $(".blocked").addClass("desktop-view-only");

            followingCourts.each(function() {

                var courtId = $(this).data("id");

                var court = $(".court[data-id='" + courtId + "']");
                court.removeClass("desktop-view-only");
                court.addClass("first-court");

                var slot = $(".slot[data-court='" + courtId + "']");
                slot.removeClass("desktop-view-only");
                slot.addClass("first-court");

                var reservation = $(".reservation[data-court='" + courtId + "']");
                reservation.removeClass("desktop-view-only");

                var blocked = $(".blocked[data-court='" + courtId + "']");
                blocked.removeClass("desktop-view-only");
            });
        });
    }

    function registerAutoRefreshListener(table) {
        setInterval(function() {
            table.trigger("reservation-change");
        }, ebusy.autoRefresh.timeout * 1000);
    }

    function registerIdleDayTimeUpdater(moduleConfig) {

        // Switch to the currently running booking day in kiosk mode if idle.
        $(document).idle({
            onIdle: function(){
                var bookingDay = dateFormat(getCurrentBookingDay(moduleConfig), "mm/dd/yyyy");
                if (ebusy.currentDate !== bookingDay) {
                    window.location.href = window.location.pathname + "?selectedDate=" + bookingDay;
                }
            },
            idle: 90000,
            recurIdleCall: true
        });
    }

    /**
     * The booking day currently running. Usually today - but if the module's
     * booking day crosses midnight (begin >= end), yesterday's booking day is
     * still running until the module's end time.
     */
    function getCurrentBookingDay(moduleConfig) {

        var now = new Date();
        var dayBegin = moduleConfig.dayBegin;
        var dayEnd = moduleConfig.dayEnd;

        if (!dayBegin || !dayEnd || dayBegin < dayEnd) {
            return now;
        }

        var nowTime = ("0" + now.getHours()).slice(-2) + ":" + ("0" + now.getMinutes()).slice(-2);

        if (nowTime < dayEnd) {
            now.setDate(now.getDate() - 1);
        }

        return now;
    }
    
    function registerAutoScroll() {

        // Switch to current time if idle.
        var scrollToCurrentTime = function(){

            var currentTimeRow = $("tr.current-time");

            if(!currentTimeRow.length) {
                return;
            }

            $('html, body').animate({
                scrollTop: currentTimeRow.offset().top - 250
            }, 500);
        };

        $(document).idle({
            onIdle: scrollToCurrentTime,
            idle: 90000,
            recurIdleCall: true
        });

        scrollToCurrentTime();
    }

    function clearAllCourtRelations(table) {
        table.find(".blocked .slot-label").show();
        table.find(".blocked").addClass("slot").removeClass("blocked");
    }

    function applyCourtRelations(courtRelations, reservations, table) {
        courtRelations.forEach(function(relation) {
            reservations.forEach(function(reservation) {
                if(reservation.court != relation.court) {
                    return;
                }

				if(!reservation.blocksRelatedCourts) {
					return;
				}

                relation.relatedCourts.forEach(function(relatedCourt) {
                    createCourtRelationBlock(relatedCourt, reservation.date, reservation.fromTime, reservation.toTime, table);
                });
            });
        });
    }

    /**
     * Applies a "blocked" layout to courts blocked by other courts
     */
    function createCourtRelationBlock(court, date, fromTime, toTime, table) {

        var cells = getCellsByData(
            court,
            date,
            fromTime,
            toTime, table
        );

        if(!cells.length) {
            return;
        }

        var majorBegin = cells.first().data("major-begin");
        var minorBegin = cells.first().data("minor-begin");

        if(majorBegin !== minorBegin) {
            table.find(".slot")
                .filter("[data-court='" + court + "']")
                .filter("[data-date='" + date + "']")
                .filter("[data-major-begin='" + majorBegin + "']")
                .filter("[data-minor-begin='" + majorBegin + "']")
                .find(".slot-label").hide();
        }

        cells.addClass("blocked").removeClass("slot").find(".slot-label").hide();
    }

    /**
     * Advance current-time marker
     */
    function initCurrentTimeMarker(table) {

        updateCurrentTimeMarker();
        setInterval(updateCurrentTimeMarker, 60000);

        function updateCurrentTimeMarker() {

            var currentTime = new Date().getTime();
            var $currentlyMarkedRows = $("tr.current-time");

            var $allRows = table.find("td[data-major-begin]:first-of-type, th[data-major-begin]:first-of-type");

            var rowContainingCurrentTime = $allRows.filter(function(index) {
                var majorStartTime = getDateTime($(this), "major-begin").getTime();
                var majorEndTime = getMajorEndTime($(this));
                return currentTime >= majorStartTime && currentTime < majorEndTime;
            });

            var $rowsToMark = $("tr").has("td[data-major-begin='" + rowContainingCurrentTime.data("major-begin") + "']");

            // current time is before last slot
            if (currentTime < getDateTime($allRows.first(), "major-begin").getTime()) {
                removeCurrentTimeMarker($currentlyMarkedRows);
                return;
            }

            // current time is after last slot
            if (currentTime > getMajorEndTime($allRows.last())) {
                markRowsAsPast($currentlyMarkedRows, $rowsToMark);
                removeCurrentTimeMarker($currentlyMarkedRows);
                return;
            }

            // current time marker already set correctly
            if($rowsToMark.first().index() === $currentlyMarkedRows.first().index()) {
                return;
            }

            removeCurrentTimeMarker($currentlyMarkedRows);

            markRowsAsPast($currentlyMarkedRows, $rowsToMark);

            applyCurrentTimeMarker($rowsToMark);
        }

        function getMajorEndTime($element) {

            var majorStartTime = getDateTime($element, "major-begin").getTime();
            var majorEndTime = getDateTime($element, "major-end").getTime();

            // data-major-end holds a time of day only; if it is not after the begin
            // time, the major slot crosses midnight and ends on the following day
            if (majorEndTime <= majorStartTime) {
                majorEndTime += 24 * 60 * 60 * 1000;
            }

            return majorEndTime;
        }

        function getDateTime($element, timeDataKey) {
            var dateString = $element.data("date-iso");
            var dateDate = new Date(dateString);

            var timeString = $element.data(timeDataKey);
            var hours = parseInt(timeString.substring(0, 2));
            var minutes = parseInt(timeString.substring(3));

			var isPm = timeString.toLowerCase().indexOf("pm") !== -1 && hours !== 12;

            var result = new Date();
            result.setFullYear(dateDate.getFullYear());
            result.setMonth(dateDate.getMonth());
            result.setDate(dateDate.getDate());
            result.setHours(hours + (isPm ? 12 : 0));
            result.setMinutes(minutes);
            result.setSeconds(0);
            result.setMilliseconds(0);

            return result;
        }

        function markRowsAsPast($fromRows, $toRows) {

            var $pastRows = table.find("tr").filter(function() {
                return $fromRows.length === 0 || $(this).index() >= $fromRows.first().index();
            }).filter(function() {
                return $toRows.length === 0 || $(this).index() < $toRows.first().index();
            });

            var pastLabel = table.data("past-label");

            $pastRows
                .find("td")
                .addClass("past-time");
            $pastRows
                .find("td")
                .not(".reservation")
                .empty();
            $pastRows
                .filter(".major-begin")
                .find("td")
                .not(".reservation")
                .html("<div class='slot-label past'><span>" + pastLabel + "</span></div>");
        }

        function removeCurrentTimeMarker($rows) {
            $rows.removeClass("current-time last-current-time current-time-end");
        }

        function applyCurrentTimeMarker($rows) {

            $rows.addClass("current-time");
            $rows.last().addClass("last-current-time");

            var currentLabel = table.data("current-label");

            $rows
                .filter(".major-begin")
                .find("td")
                .not(".reservation")
                .html("<div class='slot-label bookable'><span>" + currentLabel + "</span></div>");

            if($rows.last().index() === table.find("tr").last().index()) {
                $rows.last().addClass("current-time-end");
            }
        }
    }

    function initPrintViewButton(moduleConfig) {

        $("#print-view").on("click", function() {
            var pastTime = $(".past-time");
            var currentTime = $(".current-time");
            var currentTimeEnd = $(".current-time-end");
            var lastCurrentTime= $(".last-current-time");
            var positionSticky= $(".table-booking-module.sticky-header thead tr th, .table-booking-module.sticky-header thead tr th");

            $(pastTime).removeClass("past-time");
            $(currentTime).removeClass("current-time");
            $(currentTimeEnd).removeClass("current-time-end");
            $(lastCurrentTime).removeClass("last-current-time");
            $(positionSticky).css("position", "relative");

            $(positionSticky).each(function() {
                $(this).data("cssTop", $(this).css("top"));
                $(this).css("top", "0px");
            });

            html2canvas(document.querySelector(".table-wrap")).then(function(canvas) {
                ebusy.post("/" + moduleConfig.type + "-module/" + ebusy.moduleId + "/print-view", {data: canvas.toDataURL("image/jpeg", 0.5)});
                $("input[name='data']").closest("form").remove();

                $(positionSticky).each(function() {
                    $(this).css("top", $(this).data("cssTop"));
                });

                $(positionSticky).css("position", "sticky");
                $(pastTime).addClass("past-time");
                $(currentTime).addClass("current-time");
                $(currentTimeEnd).addClass("current-time-end");
                $(lastCurrentTime).addClass("last-current-time");
            });
        });
    }

})(window.ebusy = window.ebusy || {}, window.jQuery);
